import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Custom Tailwind text utilities are sizes, so they must not replace a color.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["figure", "title", "tile-title", "section", "body", "ui", "meta", "small", "key"],
      radius: ["control", "overlay"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
